module.exports = require('./helpers/bundle-url').getBundleURL('kY0ao') + "logo-dark.eefe0b7f.svg";